/**
 * Centralized user-facing copy for the Mail-on-Demand pricing-config admin
 * page. Interpolated with `formatMessage` from the parent print-shop feature
 * (same `{token}` convention used across the repo's string catalogs).
 */
export const pricingConfigStrings = {
  pageTitle: 'Mail-on-Demand Pricing',
  sectionTitle: 'Pricing per asset kind',
  sectionHint:
    'Only one configuration can be active per asset kind. Creating or activating a configuration automatically deactivates the previous active one for that kind.',
  createButton: 'New pricing config',
  refreshButton: 'Refresh',
  columns: {
    assetKind: 'Asset kind',
    creditsPerRecipient: 'Credits per recipient',
    minQuantity: 'Min. quantity',
    status: 'Status',
    actions: 'Actions',
  },
  activeBadge: 'Active',
  inactiveBadge: 'Inactive',
  empty: 'No pricing configurations yet. Create one to enable MOD checkout.',
  loadError: 'Could not load the pricing configurations. Please try again.',
  editButton: 'Edit',
  deactivateButton: 'Deactivate',
  form: {
    createTitle: 'New pricing config',
    editTitle: 'Edit pricing config — {assetKind}',
    assetKindLabel: 'Asset kind',
    assetKindLockedHint: 'The asset kind cannot be changed after creation.',
    creditsPerRecipientLabel: 'Credits per recipient',
    minQuantityLabel: 'Minimum quantity',
    isActiveLabel: 'Active',
    isActiveHint:
      'Activating this configuration deactivates the current active one for the same asset kind.',
    saveButton: 'Save',
    cancelButton: 'Cancel',
    errors: {
      creditsPerRecipient: 'Credits per recipient must be a number greater than 0.',
      minQuantity: 'Minimum quantity must be a whole number of at least 1.',
    },
  },
  deactivate: {
    title: 'Deactivate pricing config',
    message:
      'Deactivate the {assetKind} configuration ({credits} credits per recipient)? Members will not be able to pay for {assetKind} mailings until another configuration is activated.',
    confirmButton: 'Yes, deactivate',
    cancelButton: 'Cancel',
  },
  messages: {
    createSuccess: 'Pricing config for {assetKind} created.',
    updateSuccess: 'Pricing config for {assetKind} updated.',
    deactivateSuccess: 'Pricing config for {assetKind} deactivated.',
    saveError: 'Could not save the pricing config. Please try again.',
    deactivateError:
      'Could not deactivate the pricing config. Please try again.',
  },
} as const;
